import { TParams } from "@/types/common";
import { useMutation, useQuery } from "react-query";
import { pageData } from "@/api/pageData";
import { TPageData } from "@/types/pageData";

export const homePageData = async (params: TParams): Promise<TPageData> => {
  try {
    const res = await pageData.homePageData(params);
    return res?.data;
  } catch (err: any) {
    throw err;
  }
};

export const useGetHomePageData = (params: TParams) => {
  return useQuery(
    ["landing_site_page_data_v2", params],
    () => homePageData(params),
    {
      cacheTime: 1800000,
      staleTime: 1800000,
    }
  );
};
